import React, { useImperativeHandle } from 'react';
import { i18n } from 'fishx';
import get from 'lodash/get';
import { Form, Select } from '@whalecloud/fdx';
import FMCMember from '@/components/PortalDSCM/FMCMember';

const { Option } = Select;

const FMCForm = props => {
  const { offerInfo, form, refInstance, modelKey, tabKey, onCollapseChange, activeDepPlanPanels } = props;
  const { getFieldDecorator, validateFields } = form;

  useImperativeHandle(refInstance, () => ({
    getFMCInfo: async () => {
      await validateFields((err, value) => {
        if (err) {
          activeDepPlanPanels.push(tabKey);
          onCollapseChange([...new Set(activeDepPlanPanels)]); // 去重
        }
      });
      const FMCArr = getFMCAttr();
      const FMCfellowNbrList = getFMCfellowNbrList();
      return {
        FMCArr,
        FMCfellowNbrList,
      };
    },
  }));

  const getFMCTypeList = () => {
    return get(offerInfo?.attrDtoList.find(item => item.attrCode === 'BSNL_FMC_TYPE'), 'attrValueDtoList') || [];
  };

  const getFMCMemberLimit = () => {
    return get(offerInfo?.attrDtoList.find(item => item.attrCode === 'BSNL_FMC_MEM_LIMIT'), 'defaultValue') || 1;
  };

  const getFMCAttr = async() => {
    const attrList = [];
    const { fmcType } = await validateFields();
    attrList.push({
      attrCode: 'BSNL_FMC_TYPE',
      value: fmcType,
      attrValue: fmcType,
    });
    return attrList;
  };

  const getFMCfellowNbrList = async() => {
    const { fellowNbrFNFList } = await validateFields();
    const attrList = fellowNbrFNFList?.map(item => {
      const { subsId, key, ...otherItem } = item;
      otherItem.operationType = 'A';
      if (subsId) {
        otherItem.subsId = subsId;
      }
      return otherItem;
    });
    return attrList || [];
  };

  return (
    <Form layout="inline">
      <Form.Item label={i18n('FMC_TYPE')}>
        {getFieldDecorator('fmcType', {
          rules: [{
            required: true,
            message: i18n('COMMON_PLEASE_SELECT'),
          }],
        })(
          <Select
            // labelInValue
            placeholder={i18n('COMMON_PLEASE_SELECT')}
          >
            {
              getFMCTypeList().map(item =>
                <Option key={item.value} value={item.value}>{item.valueMark}</Option>
              )
            }
          </Select>
        )}
      </Form.Item>
      <Form.Item label={i18n('FMC_MEMBER')}>
        {getFieldDecorator('fellowNbrFMCList', {
          rules: [{
            required: true,
            message: i18n('COMMON_PLEASE_SELECT'),
          }],
        })(
          <FMCMember memberLimit={getFMCMemberLimit()} modelKey={modelKey} />
        )}
      </Form.Item>
    </Form>
  );
};

const Component = Form.create({
  onValuesChange: (props, changedValues, allValues) => {
    const { fmcType, fellowNbrFMCList = [] } = allValues;
    const attrList = [];
    attrList.push({
      attrCode: 'BSNL_FMC_TYPE', // 这个数据怎么传待定
      value: fmcType,
      attrValue: fmcType,
    });
    let fellowNbrDtoList = [];
    if (fellowNbrFMCList) {
      fellowNbrDtoList = fellowNbrFMCList.map(item => {
        const { subsId, key, ...otherItem } = item;
        otherItem.operationType = 'A';
        if (subsId) {
          otherItem.subsId = subsId;
        }
        return otherItem;
      });
    }
    const result = {
      attrList,
      fellowNbrDtoList,
    };
    const { onChange } = props;
    onChange(result);
  },
})(FMCForm);

export default React.forwardRef((props, ref) => <Component {...props} refInstance={ref} />);
